module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Celcium-fd0da51d781ba8e254f67c8d0affb862.svg";